module.exports = __webpack_public_path__ + "img/menu2-3.19c5abbd.jpg";